import { createContext } from 'react';

export interface SignInCredentials {
  email: string;
  password: string;
}

export interface User {
  id: string;
  email: string;
  full_name: string;
  profile_picture?: string;
  phone_number?: string;
  cpf?: string;
  last_login?: string;
  created_at: string;
  updated_at: string;
  is_active: boolean;
  is_system_admin: boolean;
}

interface AuthContextData {
  user: User | null;
  authenticated: boolean;
  loading: boolean;
  signIn: (data: SignInCredentials) => Promise<void>;
  signOut: () => void;
  refreshUserToken: () => void;
}

const AuthContext = createContext<AuthContextData>({} as AuthContextData);

export default AuthContext;
